import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionReveal } from './SectionReveal';
const forYou = ['Tenés una cartera activa con SA, SRL, abogados, colegios privados o prepagas y necesitás hacer el Encuadre de la RG 5866 sin dedicarle días de trabajo administrativo', 'Ya leíste la resolución y lo que necesitás ahora es el material operativo para implementarla, no que te la expliquen', 'Querés tener la Notificación a cada sujeto obligado documentada y enviada antes de que arranquen los primeros vencimientos', 'Trabajás solo o en un estudio chico donde cada hora de trabajo administrativo sale de tu tiempo facturable', 'Preferís pagar por algo que ya está armado antes que armar lo mismo vos desde cero'];
const notForYou = ['Buscás un curso o una capacitación sobre qué dice la RG 5866 — esto no explica la norma, la da por conocida', 'Tu cartera no tiene ningún sujeto obligado alcanzado por el nuevo régimen — si no trabajás con ninguna de esas categorías, no lo vas a usar', 'Ya tenés todo el material operativo armado para tu cartera — en ese caso tampoco lo necesitás'];
export function ForWhom() {
  return <section className="w-full bg-alt" data-id="element-90" data-mp="1t85puqpbfq0p">
      <div className="mx-auto max-w-4xl px-5 py-16 md:py-20" data-id="element-91" data-mp="1ff6duyoqsdxw">
        <SectionReveal data-id="element-92" data-mp="1fctxur2jodnh">
          <h2 className="text-center text-2xl font-black leading-tight text-ink sm:text-3xl md:text-4xl" data-id="element-93" data-mp="1kdhnp9f1eog4">
            ¿Este pack es para tu estudio?
          </h2>
        </SectionReveal>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-94" data-mp="1afk10qctszpm">
          <SectionReveal data-id="element-95" data-mp="1ah4su87ra4js">
            <div className="h-full rounded-2xl border border-greenlive/30 bg-base p-6 shadow-sm" data-id="element-96" data-mp="1ad79blh9nazd">
              <h3 className="text-lg font-black text-greenlive" data-id="element-97" data-mp="wi54z2s2htoo">
                ✅ ES PARA VOS SI:
              </h3>
              <ul className="mt-4 space-y-4" data-id="element-98" data-mp="2qu34gd0krb7d">
                {forYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-99" data-mp="2vswgs244kw5y" data-mpi={i}>
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-greenlive" strokeWidth={2.6} data-id="element-100" data-mp="2vs4y1rvmmsx3" />
                    <span className="text-[15px] leading-relaxed text-ink" data-id="element-101" data-mp="2pbl8x3md773m">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </SectionReveal>

          <SectionReveal delay={0.1} data-id="element-102" data-mp="2fgb4yaceopn7">
            <div className="h-full rounded-2xl border border-alt bg-base p-6 shadow-sm" data-id="element-103" data-mp="3d1z24xgorbzs">
              <h3 className="text-lg font-black text-ink-soft" data-id="element-104" data-mp="3835nh1pnxey1">
                ❌ NO ES PARA VOS SI:
              </h3>
              <ul className="mt-4 space-y-4" data-id="element-105" data-mp="33bvym3bxufn7">
                {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-106" data-mp="2yduhvp1zisew" data-mpi={i}>
                    <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-strike" strokeWidth={2.6} data-id="element-107" data-mp="2ybi3flvfr06l" />
                    <span className="text-[15px] leading-relaxed text-ink-soft" data-id="element-108" data-mp="3r187f23csloz">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </SectionReveal>
        </div>
      </div>
    </section>;
}